import React from 'react';
import COMPANY_INFO from '../data/companyInfo';

// The two signature lines at the bottom of a printed document: someone authorized at the company, and the client.
// Shared by the factura/nota, cotización, conduce and rental-contract print views. The company's line carries the
// authorized signature and the company seal (public/firma-autorizada.png, made by backend/scripts/make-signature-stamp.py).
// clientLabel: what the client's line says — "Recibido por el cliente" unless the client is handing something back
// (a rental's conduce de retiro). showClient={false}: only the company's signature, centered (the recibo de ingreso).
const SignatureLines = ({ clientName, clientLabel = 'Recibido por el cliente', showClient = true }) => (
  <div className="signature-block" style={showClient ? undefined : { justifyContent: 'center' }}>
    <div className="signature-box" style={showClient ? undefined : { flex: '0 1 50%' }}>
      <div className="signature-space">
        <img src="/firma-autorizada.png" alt="Firma autorizada y sello de Intmed" className="signature-stamp" />
      </div>
      <div className="signature-line" />
      <div className="signature-label">Firma autorizada</div>
      <div className="signature-sub">{COMPANY_INFO.name}</div>
    </div>
    {showClient && <div className="signature-box">
      <div className="signature-space" />
      <div className="signature-line" />
      <div className="signature-label">{clientLabel}</div>
      <div className="signature-sub">{clientName ? `${clientName} · ` : ''}Nombre, cédula y firma</div>
    </div>}
  </div>
);

export default SignatureLines;
